export const LOGIN = 'innovA-auction/authorization#login';
export const REFRESH = 'innovA-auction/authorization#refresh';
export const HANDOFF = 'innovA-auction/authorization#handoff';
export const SET_ERROR = 'innovA-auction/authorization/setError';
export const LOGOUT = 'innovA-auction/authorization#logout';
export const UPDATE_AUTHORIZATION_STATE = 'innovA-auctions/authorization#updateAuthorizationState';
export const PROXY = 'innovA-auction/authorization#proxy';
export const APP_CLEAR_STORE = 'blackbird_api/store#clear';
export const GET_PAGE_CONTENT = 'innovA/content#getPageContent';
export const RESET_AUTH_ERROR = 'innovA-auction/RESET_AUTH_ERROR';